var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveclaims(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0801 4.09814H18.0801C18.6105 4.09814 19.1192 4.30886 19.4943 4.68393C19.8694 5.059 20.0801 5.56771 20.0801 6.09814V20.0981C20.0801 20.6286 19.8694 21.1373 19.4943 21.5124C19.1192 21.8874 18.6105 22.0981 18.0801 22.0981H6.08008C5.54965 22.0981 5.04094 21.8874 4.66586 21.5124C4.29079 21.1373 4.08008 20.6286 4.08008 20.0981V6.09814C4.08008 5.56771 4.29079 5.059 4.66586 4.68393C5.04094 4.30886 5.54965 4.09814 6.08008 4.09814H8.08008",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H9C8.44772 6 8 6.44772 8 7V9C8 9.55228 8.44772 10 9 10H15C15.5523 10 16 9.55228 16 9V7C16 6.44772 15.5523 6 15 6Z",
    fill: "url(#paint0_linear_2514_5290)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0801 2.09814H9.08008C8.52779 2.09814 8.08008 2.54586 8.08008 3.09814V5.09814C8.08008 5.65043 8.52779 6.09814 9.08008 6.09814H15.0801C15.6324 6.09814 16.0801 5.65043 16.0801 5.09814V3.09814C16.0801 2.54586 15.6324 2.09814 15.0801 2.09814Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2514_5290",
    x1: 12,
    y1: 6,
    x2: 12,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveclaims);
export default __webpack_public_path__ + "static/media/activeclaims.f4ae3614ca5a326636cae9657c2e4b66.svg";
export { ForwardRef as ReactComponent };